import { useEffect, useState } from 'react'
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

interface Props {
  visible: boolean
  onClose: () => void
  onClosePermanent: () => void
}

export default function HeroBanner({ visible, onClose, onClosePermanent }: Props) {
  const [countdown, setCountdown] = useState<number | null>(null)

  useEffect(() => {
    if (!visible) return
    const timer = setTimeout(onClose, 10000)
    return () => clearTimeout(timer)
  }, [visible, onClose])

  useEffect(() => {
    if (!visible) return
    const countdownTimer = setTimeout(() => setCountdown(5), 5000)
    return () => clearTimeout(countdownTimer)
  }, [visible])

  useEffect(() => {
    if (countdown === null) return
    if (countdown === 0) { 
        setTimeout(onClose, 0)
        return 
    }
    const timer = setTimeout(() => setCountdown(c => c !== null ? c - 1 : null), 1000)
    return () => clearTimeout(timer)
  }, [countdown, onClose])

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 170 }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="relative w-full mb-2 rounded-sm overflow-hidden md:hidden"
          style={{ height: 170 }}
        >
          <video autoPlay muted loop playsInline
            className="absolute inset-0 w-full h-full object-cover"
            src="https://scpwgmuctwhwhqepbxzd.supabase.co/storage/v1/object/public/product-images/banner-animation-video.mp4"
          />
          <div className="absolute inset-0 bg-black/35" />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 z-10">
            <motion.h2
              initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif text-white text-[22px] font-bold tracking-tight text-center drop-shadow-lg"
            >
              ירקות ופירות טריים
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-white/80 text-[14px] font-medium text-center"
            >
              איכות חקלאית מהשדה לעסק שלך
            </motion.p>
          </div>
          <button onClick={onClosePermanent}
            className="absolute top-3 left-3 z-20 w-7 h-7 rounded-full bg-black/30 hover:bg-black/50
                       flex items-center justify-center border-none cursor-pointer transition-colors"
            aria-label="סגור באנר"
          >
            <X className="w-4 h-4 text-white" />
          </button>
          {countdown !== null && (
            <div className="absolute bottom-3 right-3 z-20 w-6 h-6 rounded-full bg-black/40 flex items-center justify-center">
              <span className="text-white text-[11px] font-bold">{countdown}</span>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
